/* Scoped visual accents and visible-only ambient motion. Never intercept commerce. */
(function () {
  'use strict';
  if (window.__icarsoftBF2026Motion) {
    window.__icarsoftBF2026Motion.init(document);
    return;
  }
  const roots = new Map();
  const rootSelector = '[data-icbf2026]';
  const accentSelector = '.icbf-medal,.icbf-trio-medal,.icbf-spot-medal,.icbf-price-now,.icbf-trio-price .icbf-now,.icbf-spot-price .icbf-now,.icbf-btn-gold,.icbf-codechip,.icbf-receipt';
  const groupSelector = '.icbf-card,.icbf-trio-card,.icbf-spot-pane,.icbf-btn-gold,.icbf-codechip,.icbf-receipt';
  const rootsWithin = scope => scope.matches && scope.matches(rootSelector)
    ? [scope] : Array.from(scope.querySelectorAll(rootSelector));

  function mount(root) {
    const gsap = window.gsap;
    if (roots.has(root) || !gsap || typeof gsap.matchMedia !== 'function') return;
    const media = gsap.matchMedia();
    let motionPaused = false;
    roots.set(root, () => {
      media.revert();
      roots.delete(root);
    });
    media.add('(prefers-reduced-motion: no-preference)', context => {
      const controller = new AbortController();
      const signal = controller.signal;
      const shines = new Map();
      const running = new Set();
      const reusable = new Set();
      const seen = new WeakSet();
      const hero = root.querySelector('.icbf-hero');
      const headings = new Set(root.querySelectorAll('[data-bf-heading]'));
      const headingTimelines = new Map();
      const enteredHeadings = new Set();
      const receiptIntros = new Map();
      const receiptTimelines = new Map();
      const receiptButtons = root.querySelectorAll('[data-bf-receipt-replay]');
      const motionToggle = root.querySelector('[data-bf-motion-toggle]');
      const ambient = new Set(root.querySelectorAll('[data-bf-ambient]'));
      const visibleAmbient = new Set();
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      let observer = null;
      let heroPlayed = false;

      function track(animation) {
        running.add(animation);
        const release = () => running.delete(animation);
        animation.eventCallback('onComplete', release);
        animation.eventCallback('onInterrupt', release);
        return animation;
      }

      function shine(group) {
        if (document.hidden || motionPaused || !group || group.closest('[hidden]')) return;
        const accents = [...group.querySelectorAll(accentSelector)];
        if (group.matches(accentSelector)) accents.unshift(group);
        accents.forEach(element => {
          // Ignore repeated pointer/focus events while a reflection is in progress.
          if (shines.has(element)) return;
          element.classList.add('icbf-is-shining');
          const timer = window.setTimeout(() => {
            element.classList.remove('icbf-is-shining');
            shines.delete(element);
          }, 1100);
          shines.set(element, timer);
        });
      }

      function finishMotion() {
        Array.from(running).forEach(animation => {
          animation.progress(1);
          if (reusable.has(animation)) animation.pause();
          else animation.kill();
        });
        shines.forEach((timer, element) => {
          window.clearTimeout(timer);
          element.classList.remove('icbf-is-shining');
        });
        shines.clear();
      }

      function syncAmbient() {
        ambient.forEach(element => element.classList.toggle('is-ambient-active',
          !document.hidden && !motionPaused && visibleAmbient.has(element) && !element.closest('[hidden]')));
      }

      function syncControl() {
        root.classList.toggle('is-motion-paused', motionPaused);
        if (!motionToggle) return;
        motionToggle.setAttribute('aria-pressed', String(motionPaused));
        motionToggle.textContent = motionPaused ? 'Resume motion' : 'Pause motion';
        motionToggle.hidden = false;
      }

      // Context methods also capture animations created later by observers/events.
      context.add('heroIntro', () => {
        if (!hero || heroPlayed || document.hidden || motionPaused) return;
        heroPlayed = true;
        const title = hero.querySelector('h1');
        if (!title) return;
        const lines = title.querySelectorAll('.icbf-row1,.icbf-row2');
        const script = title.querySelector('.icbf-script');
        // Keep the authored signature angle on the outer wrapper.
        const signature = script && (script.querySelector('.icbf-signature-text') || script);
        const glint = title.querySelector('.icbf-title-glint');
        const tl = track(gsap.timeline({ defaults: { ease: 'power3.out' } }));
        tl.addLabel('lettering', 0).addLabel('signature', 0.34).addLabel('reflection', 0.72);
        if (lines.length) tl.fromTo(lines, { x: index => index ? 14 : -14, y: 26, opacity: 0 }, {
          x: 0, y: 0, opacity: 1, duration: 1.08, stagger: 0.16,
          clearProps: 'transform,opacity'
        }, 'lettering');
        if (signature) tl.fromTo(signature, { x: 20, y: 8, opacity: 0 }, {
          x: 0, y: 0, opacity: 1, duration: 0.9, clearProps: 'transform,opacity'
        }, 'signature');
        if (glint) {
          tl.fromTo(glint, { xPercent: -100, opacity: 0 }, {
            xPercent: 900, duration: 1.45, ease: 'power2.inOut'
          }, 'reflection');
          tl.to(glint, { opacity: 0.48, duration: 0.28 }, 'reflection+=0.06');
          tl.to(glint, { opacity: 0, duration: 0.45, clearProps: 'transform,opacity' }, 'reflection+=1');
        }
      });

      context.add('spotlight', panel => {
        if (!panel || panel.hidden || document.hidden || motionPaused) return;
        finishMotion();
        const visual = panel.querySelector('.icbf-spot-frame');
        const content = panel.querySelectorAll('.icbf-spot-info > *');
        if (visual || content.length) {
          const tl = track(gsap.timeline({ defaults: { ease: 'power3.out', clearProps: 'transform,opacity' } }));
          if (visual) tl.fromTo(visual, { x: -18, y: 6, opacity: 0.45 }, {
            x: 0, y: 0, opacity: 1, duration: 0.68
          }, 0);
          if (content.length) tl.fromTo(content, { x: 16, opacity: 0.3 }, {
            x: 0, opacity: 1, duration: 0.5, stagger: 0.055
          }, 0.1);
        }
        shine(panel);
      });

      context.add('headingIntro', heading => {
        if (document.hidden || motionPaused || !heading || heading.closest('[hidden]')) return;
        let tl = headingTimelines.get(heading);
        if (!tl) {
          const lead = heading.querySelector('.icbf-heading-lead');
          const script = heading.querySelector('.icbf-script');
          const glint = heading.querySelector('.icbf-heading-glint');
          tl = gsap.timeline({ paused: true, defaults: { ease: 'power3.out' } });
          tl.addLabel('lettering', 0).addLabel('signature', 0.18).addLabel('reflection', 0.6);
          if (lead) tl.fromTo(lead, { x: -18, y: 18, opacity: 0 }, {
            x: 0, y: 0, opacity: 1, duration: 0.95, clearProps: 'transform,opacity'
          }, 'lettering');
          if (script) tl.fromTo(script, { x: 18, y: 14, opacity: 0 }, {
            x: 0, y: 0, opacity: 1, duration: 1.1, clearProps: 'transform,opacity'
          }, 'signature');
          if (glint) {
            tl.fromTo(glint, { xPercent: -100, opacity: 0 }, {
              xPercent: 850, duration: 1.2, ease: 'power2.inOut'
            }, 'reflection');
            tl.to(glint, { opacity: 0.46, duration: 0.2 }, 'reflection+=0.06');
            tl.to(glint, { opacity: 0, duration: 0.4, clearProps: 'transform,opacity' }, 'reflection+=0.8');
          }
          headingTimelines.set(heading, tl);
          reusable.add(tl);
        }
        track(tl).restart();
      });

      function receiptReflection(tl, receipt, at) {
        const sheen = receipt.querySelector('.icbf-receipt-sheen');
        if (!sheen) return;
        tl.fromTo(sheen, { xPercent: 0, opacity: 0 }, {
          xPercent: 330, duration: 1.2, ease: 'power2.inOut'
        }, at);
        // Keep the highlight visible between fade-in and fade-out; the final tween cleans it up.
        tl.to(sheen, { opacity: 0.6, duration: 0.22, clearProps: '' }, at + 0.08);
        tl.to(sheen, { opacity: 0, duration: 0.3, clearProps: 'transform,opacity' }, at + 0.9);
      }

      context.add('receiptIntro', receipt => {
        if (!receipt || document.hidden || motionPaused || receipt.closest('[hidden]') || receiptIntros.has(receipt)) return;
        const tl = track(gsap.timeline({ defaults: { ease: 'power3.out', clearProps: 'transform,opacity' } }));
        receiptIntros.set(receipt, tl);
        tl.fromTo(receipt, { y: 20, opacity: 0.65 }, { y: 0, opacity: 1, duration: 0.7 }, 0);
        const rows = receipt.querySelectorAll('.icbf-r-row');
        if (rows.length) tl.fromTo(rows, { x: -9, opacity: 0.6 }, { x: 0, opacity: 1, duration: 0.5, stagger: 0.13 }, 0.16);
        const shield = receipt.querySelector('.icbf-shield');
        if (shield) tl.fromTo(shield, { scale: 0.94, rotation: -4 }, { scale: 1, rotation: 0, duration: 0.72 }, 0.1);
        const total = receipt.querySelector('.icbf-r-total');
        if (total) tl.fromTo(total, { y: 9, opacity: 0.65 }, { y: 0, opacity: 1, duration: 0.6 }, 0.4);
        receiptReflection(tl, receipt, 0.24);
        shine(receipt);
      });

      context.add('receiptInteraction', receipt => {
        if (!receipt || document.hidden || motionPaused || receipt.closest('[hidden]')) return;
        if (running.has(receiptIntros.get(receipt))) return;
        let tl = receiptTimelines.get(receipt);
        if (tl && running.has(tl)) return;
        if (!tl) {
          tl = gsap.timeline({ paused: true, defaults: { ease: 'power3.out', clearProps: 'transform,opacity' } });
          const shield = receipt.querySelector('.icbf-shield');
          if (shield) tl.fromTo(shield, { scale: 0.97, rotation: -3 }, { scale: 1, rotation: 0, duration: 0.7 }, 0);
          const value = receipt.querySelector('.icbf-t-val');
          if (value) tl.fromTo(value, { y: 4 }, { y: 0, duration: 0.65 }, 0.15);
          receiptReflection(tl, receipt, 0);
          receiptTimelines.set(receipt, tl);
          reusable.add(tl);
        }
        shine(receipt);
        track(tl).restart();
      });

      const observed = [hero, ...root.querySelectorAll(groupSelector)].filter(Boolean);
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          if (signal.aborted) return;
          entries.forEach(entry => {
            if (headings.has(entry.target)) {
              if (!entry.isIntersecting) {
                enteredHeadings.delete(entry.target);
                const tl = headingTimelines.get(entry.target);
                if (tl) tl.progress(1).pause();
              } else if (entry.intersectionRatio >= 0.16 && !document.hidden && !motionPaused && !enteredHeadings.has(entry.target)) {
                enteredHeadings.add(entry.target);
                context.headingIntro(entry.target);
              }
              return;
            }
            if (ambient.has(entry.target)) {
              if (entry.isIntersecting && entry.intersectionRatio > 0) visibleAmbient.add(entry.target);
              else visibleAmbient.delete(entry.target);
              return;
            }
            if (document.hidden || motionPaused) return;
            if (!entry.isIntersecting || seen.has(entry.target)) return;
            seen.add(entry.target);
            observer.unobserve(entry.target);
            if (entry.target === hero) context.heroIntro();
            else if (entry.target.matches('.icbf-receipt')) context.receiptIntro(entry.target);
            else shine(entry.target);
          });
          syncAmbient();
        }, { threshold: 0.16 });
        observed.forEach(element => observer.observe(element));
        ambient.forEach(element => observer.observe(element));
        headings.forEach(element => observer.observe(element));
      } else if (hero) {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) context.heroIntro();
      }

      function resumeVisibleMotion() {
        if (document.hidden || motionPaused) return;
        // Recheck current intersections before restarting background animation.
        visibleAmbient.clear();
        syncAmbient();
        if (observer) {
          [...observed.filter(element => !seen.has(element)), ...ambient, ...headings].forEach(element => {
            observer.unobserve(element);
            observer.observe(element);
          });
        } else if (hero && !heroPlayed) {
          const rect = hero.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) context.heroIntro();
        }
      }

      syncControl();
      if (motionToggle) motionToggle.addEventListener('click', () => {
        motionPaused = !motionPaused;
        syncControl();
        syncAmbient();
        if (motionPaused) finishMotion();
        else resumeVisibleMotion();
      }, { signal });

      root.addEventListener('pointerover', event => {
        if (!finePointer.matches) return;
        const group = event.target.closest(groupSelector);
        if (!group || !root.contains(group) || (event.relatedTarget && group.contains(event.relatedTarget))) return;
        if (group.matches('.icbf-receipt')) context.receiptInteraction(group);
        else shine(group);
      }, { signal, passive: true });
      root.addEventListener('focusin', event => {
        const group = event.target.closest(groupSelector);
        if (group && root.contains(group)) {
          if (group.matches('.icbf-receipt')) context.receiptInteraction(group);
          else shine(group);
        }
      }, { signal });
      receiptButtons.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => context.receiptInteraction(button.closest('.icbf-receipt')), { signal });
      });
      root.addEventListener('icarsoft:bf2026:spotchange', event => {
        context.spotlight(event.detail && event.detail.panel);
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          finishMotion();
          syncAmbient();
        } else {
          resumeVisibleMotion();
        }
      }, { signal });

      return () => {
        controller.abort();
        if (observer) observer.disconnect();
        finishMotion();
        headingTimelines.forEach(tl => tl.kill());
        headingTimelines.clear();
        receiptIntros.forEach(tl => tl.kill());
        receiptIntros.clear();
        receiptTimelines.forEach(tl => tl.kill());
        receiptTimelines.clear();
        receiptButtons.forEach(button => { button.hidden = true; });
        enteredHeadings.clear();
        reusable.clear();
        visibleAmbient.clear();
        ambient.forEach(element => element.classList.remove('is-ambient-active'));
        root.classList.remove('is-motion-paused');
        if (motionToggle) {
          motionToggle.hidden = true;
          motionToggle.setAttribute('aria-pressed', 'false');
          motionToggle.textContent = 'Pause motion';
        }
      };
    }, root);
  }

  function init(scope) { rootsWithin(scope).forEach(mount); }
  window.__icarsoftBF2026Motion = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    rootsWithin(event.target).forEach(root => {
      const cleanup = roots.get(root);
      if (cleanup) cleanup();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
